/**
 * Whether the main canvas's rig is resting (SceneRig.rest, M33): its frame's GPU targets given back under a screen
 * that covers the world. A second WebGL stage (the end screen's 3D chest) waits for it, so the two never hold their
 * memory at once. No imports: the UI can ask without pulling in the renderer.
 */
const waiters = new Set<() => void>();
let resting = false;

export const mainRest = {
  get resting(): boolean { return resting; },
  set(on: boolean): void {
    resting = on;
    if (!on) return;
    const due = [...waiters];
    waiters.clear();
    for (const w of due) w();
  },
  /**
   * Runs `then` once the rig rests, or after `maxMs` whatever happens (a screen without a level behind it, a
   * rig that could not rest): never later. Returns a cancel function.
   */
  whenResting(then: () => void, maxMs: number): () => void {
    let done = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const run = (): void => { if (done) return; done = true; waiters.delete(run); if (timer !== undefined) clearTimeout(timer); then(); };
    if (resting) { run(); return () => {}; }
    waiters.add(run);
    timer = setTimeout(run, maxMs);
    return () => { done = true; waiters.delete(run); if (timer !== undefined) clearTimeout(timer); };
  },
};
